import React, { memo } from "react";

// constants
import {
    PERCENTAGE_ICON_HEIGHT,
    PERCENTAGE_ICON_WIDTH,
    SAVINGS_IMAGE_IDS,
} from "@payment-ui/components/tick-screen/constants";

// interfaces
import { SavingIconProps } from "@payment-ui/components/tick-screen/interfaces";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

function SavingIcon({
    width = PERCENTAGE_ICON_WIDTH,
    height = PERCENTAGE_ICON_HEIGHT,
    isFreeDel,
    isToingFlow,
}: SavingIconProps) {
    if (isFreeDel) {
        return (
            <Image
                cloudinaryWidth={width * 2}
                cloudinaryHeight={height * 2}
                cloudinaryId={SAVINGS_IMAGE_IDS.FREE_DELIVERY}
                height={String(height)}
                width={String(width)}
            />
        );
    }

    if (isToingFlow) {
        return (
            <Image
                cloudinaryId={SAVINGS_IMAGE_IDS.TOING}
                height={String(height)}
                width={String(width)}
                cloudinaryWidth={width * 2}
                cloudinaryHeight={height * 2}
            />
        );
    }

    return (
        <Image
            cloudinaryId={SAVINGS_IMAGE_IDS.GENERIC}
            height={String(height)}
            width={String(width)}
            cloudinaryWidth={width * 2}
            cloudinaryHeight={height * 2}
        />
    );
}

export default memo(SavingIcon);
